import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface ISnackbarData {
  icon?: 'ri-save-line' | 'ri-close-fill' | 'ri-error-warning-fill' | 'ri-time-line';
  title: string;
  message?: string;
  action?: string;
  onAction?: () => void;
  dismissible?: boolean;
}

@Component({
    selector: 'ts-snackbar-alert',
    templateUrl: './snackbar-alert.component.html',
    styleUrls: ['./snackbar-alert.component.scss'],
    standalone: false
})
export class SnackbarAlertComponent {
  public get isInlineAction(): boolean {
    return !this.data.icon && !this.data.message && !!this.data.action;
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarData,
    @Optional() private readonly snackBarRef: MatSnackBarRef<SnackbarAlertComponent>
  ) {}

  public onActionClick(): void {
    this.data.onAction?.();
    this.snackBarRef?.dismiss();
  }

  public onCloseClick(): void {
    this.snackBarRef?.dismiss();
  }
}

@NgModule({
  imports: [CommonModule, MatSnackBarModule, MatButtonModule, TranslateModule],
  declarations: [SnackbarAlertComponent],
  exports: [SnackbarAlertComponent],
})
export class SnackbarAlertComponentModule {}
